<span class="{{ customClass }}" [ngStyle]="styleConfig" [innerHTML]="text"></span>
